;; Derived from polylith/bases/geo-location-rest-api/resources/timezones.csv
(ns lemonpi.ads-schema.timezones)

(def timezones
  [{:country "AD" :timezone "Europe/Andorra"}
   {:country "AE" :timezone "Asia/Dubai"}
   {:country "AF" :timezone "Asia/Kabul"}
   {:country "AG" :timezone "America/Antigua"}
   {:country "AI" :timezone "America/Anguilla"}
   {:country "AL" :timezone "Europe/Tirane"}
   {:country "AM" :timezone "Asia/Yerevan"}
   {:country "AN" :timezone "America/Curacao"}
   {:country "AO" :timezone "Africa/Luanda"}
   {:country "AQ" :timezone "Antarctica/South_Pole"}
   {:country "AR" :region "01" :timezone "America/Argentina/Buenos_Aires"}
   {:country "AR" :region "02" :timezone "America/Argentina/Catamarca"}
   {:country "AR" :region "03" :timezone "America/Argentina/Tucuman"}
   {:country "AR" :region "04" :timezone "America/Argentina/Rio_Gallegos"}
   {:country "AR" :region "05" :timezone "America/Argentina/Cordoba"}
   {:country "AR" :region "06" :timezone "America/Argentina/Tucuman"}
   {:country "AR" :region "07" :timezone "America/Argentina/Buenos_Aires"}
   {:country "AR" :region "08" :timezone "America/Argentina/Buenos_Aires"}
   {:country "AR" :region "09" :timezone "America/Argentina/Tucuman"}
   {:country "AR" :region "10" :timezone "America/Argentina/Jujuy"}
   {:country "AR" :region "11" :timezone "America/Argentina/San_Luis"}
   {:country "AR" :region "12" :timezone "America/Argentina/La_Rioja"}
   {:country "AR" :region "13" :timezone "America/Argentina/Mendoza"}
   {:country "AR" :region "14" :timezone "America/Argentina/Buenos_Aires"}
   {:country "AR" :region "15" :timezone "America/Argentina/San_Luis"}
   {:country "AR" :region "16" :timezone "America/Argentina/Buenos_Aires"}
   {:country "AR" :region "17" :timezone "America/Argentina/Salta"}
   {:country "AR" :region "18" :timezone "America/Argentina/San_Juan"}
   {:country "AR" :region "19" :timezone "America/Argentina/San_Luis"}
   {:country "AR" :region "20" :timezone "America/Argentina/Rio_Gallegos"}
   {:country "AR" :region "21" :timezone "America/Argentina/Buenos_Aires"}
   {:country "AR" :region "22" :timezone "America/Argentina/Catamarca"}
   {:country "AR" :region "23" :timezone "America/Argentina/Ushuaia"}
   {:country "AR" :region "24" :timezone "America/Argentina/Tucuman"}
   {:country "AS" :timezone "Pacific/Pago_Pago"}
   {:country "AT" :timezone "Europe/Vienna"}
   {:country "AU" :region "01" :timezone "Australia/Sydney"}
   {:country "AU" :region "02" :timezone "Australia/Sydney"}
   {:country "AU" :region "03" :timezone "Australia/Darwin"}
   {:country "AU" :region "04" :timezone "Australia/Brisbane"}
   {:country "AU" :region "05" :timezone "Australia/Adelaide"}
   {:country "AU" :region "06" :timezone "Australia/Hobart"}
   {:country "AU" :region "07" :timezone "Australia/Melbourne"}
   {:country "AU" :region "08" :timezone "Australia/Perth"}
   {:country "AW" :timezone "America/Aruba"}
   {:country "AX" :timezone "Europe/Mariehamn"}
   {:country "AZ" :timezone "Asia/Baku"}
   {:country "BA" :timezone "Europe/Sarajevo"}
   {:country "BB" :timezone "America/Barbados"}
   {:country "BD" :timezone "Asia/Dhaka"}
   {:country "BE" :timezone "Europe/Brussels"}
   {:country "BF" :timezone "Africa/Ouagadougou"}
   {:country "BG" :timezone "Europe/Sofia"}
   {:country "BH" :timezone "Asia/Bahrain"}
   {:country "BI" :timezone "Africa/Bujumbura"}
   {:country "BJ" :timezone "Africa/Porto-Novo"}
   {:country "BL" :timezone "America/St_Barthelemy"}
   {:country "BM" :timezone "Atlantic/Bermuda"}
   {:country "BN" :timezone "Asia/Brunei"}
   {:country "BO" :timezone "America/La_Paz"}
   {:country "BQ" :timezone "America/Curacao"}
   {:country "BR" :region "01" :timezone "America/Rio_Branco"}
   {:country "BR" :region "02" :timezone "America/Maceio"}
   {:country "BR" :region "03" :timezone "America/Sao_Paulo"}
   {:country "BR" :region "04" :timezone "America/Manaus"}
   {:country "BR" :region "05" :timezone "America/Bahia"}
   {:country "BR" :region "06" :timezone "America/Fortaleza"}
   {:country "BR" :region "07" :timezone "America/Sao_Paulo"}
   {:country "BR" :region "08" :timezone "America/Sao_Paulo"}
   {:country "BR" :region "11" :timezone "America/Campo_Grande"}
   {:country "BR" :region "13" :timezone "America/Belem"}
   {:country "BR" :region "14" :timezone "America/Cuiaba"}
   {:country "BR" :region "15" :timezone "America/Sao_Paulo"}
   {:country "BR" :region "16" :timezone "America/Belem"}
   {:country "BR" :region "17" :timezone "America/Recife"}
   {:country "BR" :region "18" :timezone "America/Sao_Paulo"}
   {:country "BR" :region "20" :timezone "America/Fortaleza"}
   {:country "BR" :region "21" :timezone "America/Sao_Paulo"}
   {:country "BR" :region "22" :timezone "America/Recife"}
   {:country "BR" :region "23" :timezone "America/Sao_Paulo"}
   {:country "BR" :region "24" :timezone "America/Porto_Velho"}
   {:country "BR" :region "25" :timezone "America/Boa_Vista"}
   {:country "BR" :region "26" :timezone "America/Sao_Paulo"}
   {:country "BR" :region "27" :timezone "America/Sao_Paulo"}
   {:country "BR" :region "28" :timezone "America/Maceio"}
   {:country "BR" :region "29" :timezone "America/Sao_Paulo"}
   {:country "BR" :region "30" :timezone "America/Recife"}
   {:country "BR" :region "31" :timezone "America/Araguaina"}
   {:country "BS" :timezone "America/Nassau"}
   {:country "BT" :timezone "Asia/Thimphu"}
   {:country "BV" :timezone "Antarctica/Syowa"}
   {:country "BW" :timezone "Africa/Gaborone"}
   {:country "BY" :timezone "Europe/Minsk"}
   {:country "BZ" :timezone "America/Belize"}
   {:country "CA" :region "AB" :timezone "America/Edmonton"}
   {:country "CA" :region "BC" :timezone "America/Vancouver"}
   {:country "CA" :region "MB" :timezone "America/Winnipeg"}
   {:country "CA" :region "NB" :timezone "America/Halifax"}
   {:country "CA" :region "NL" :timezone "America/St_Johns"}
   {:country "CA" :region "NS" :timezone "America/Halifax"}
   {:country "CA" :region "NT" :timezone "America/Yellowknife"}
   {:country "CA" :region "NU" :timezone "America/Rankin_Inlet"}
   {:country "CA" :region "ON" :timezone "America/Toronto"}
   {:country "CA" :region "PE" :timezone "America/Halifax"}
   {:country "CA" :region "QC" :timezone "America/Montreal"}
   {:country "CA" :region "SK" :timezone "America/Regina"}
   {:country "CA" :region "YT" :timezone "America/Whitehorse"}
   {:country "CC" :timezone "Indian/Cocos"}
   {:country "CD" :region "01" :timezone "Africa/Kinshasa"}
   {:country "CD" :region "02" :timezone "Africa/Kinshasa"}
   {:country "CD" :region "03" :timezone "Africa/Kinshasa"}
   {:country "CD" :region "04" :timezone "Africa/Lubumbashi"}
   {:country "CD" :region "05" :timezone "Africa/Lubumbashi"}
   {:country "CD" :region "06" :timezone "Africa/Kinshasa"}
   {:country "CD" :region "07" :timezone "Africa/Lubumbashi"}
   {:country "CD" :region "08" :timezone "Africa/Kinshasa"}
   {:country "CD" :region "09" :timezone "Africa/Lubumbashi"}
   {:country "CD" :region "10" :timezone "Africa/Lubumbashi"}
   {:country "CD" :region "11" :timezone "Africa/Lubumbashi"}
   {:country "CD" :region "12" :timezone "Africa/Lubumbashi"}
   {:country "CF" :timezone "Africa/Bangui"}
   {:country "CG" :timezone "Africa/Brazzaville"}
   {:country "CH" :timezone "Europe/Zurich"}
   {:country "CI" :timezone "Africa/Abidjan"}
   {:country "CK" :timezone "Pacific/Rarotonga"}
   {:country "CL" :timezone "America/Santiago"}
   {:country "CM" :timezone "Africa/Lagos"}
   {:country "CN" :region "01" :timezone "Asia/Shanghai"}
   {:country "CN" :region "02" :timezone "Asia/Shanghai"}
   {:country "CN" :region "03" :timezone "Asia/Shanghai"}
   {:country "CN" :region "04" :timezone "Asia/Shanghai"}
   {:country "CN" :region "05" :timezone "Asia/Harbin"}
   {:country "CN" :region "06" :timezone "Asia/Chongqing"}
   {:country "CN" :region "07" :timezone "Asia/Shanghai"}
   {:country "CN" :region "08" :timezone "Asia/Harbin"}
   {:country "CN" :region "09" :timezone "Asia/Shanghai"}
   {:country "CN" :region "10" :timezone "Asia/Shanghai"}
   {:country "CN" :region "11" :timezone "Asia/Chongqing"}
   {:country "CN" :region "12" :timezone "Asia/Shanghai"}
   {:country "CN" :region "13" :timezone "Asia/Urumqi"}
   {:country "CN" :region "14" :timezone "Asia/Chongqing"}
   {:country "CN" :region "15" :timezone "Asia/Chongqing"}
   {:country "CN" :region "16" :timezone "Asia/Chongqing"}
   {:country "CN" :region "18" :timezone "Asia/Chongqing"}
   {:country "CN" :region "19" :timezone "Asia/Harbin"}
   {:country "CN" :region "20" :timezone "Asia/Harbin"}
   {:country "CN" :region "21" :timezone "Asia/Chongqing"}
   {:country "CN" :region "22" :timezone "Asia/Harbin"}
   {:country "CN" :region "23" :timezone "Asia/Shanghai"}
   {:country "CN" :region "24" :timezone "Asia/Chongqing"}
   {:country "CN" :region "25" :timezone "Asia/Shanghai"}
   {:country "CN" :region "26" :timezone "Asia/Chongqing"}
   {:country "CN" :region "28" :timezone "Asia/Shanghai"}
   {:country "CN" :region "29" :timezone "Asia/Chongqing"}
   {:country "CN" :region "30" :timezone "Asia/Chongqing"}
   {:country "CN" :region "31" :timezone "Asia/Chongqing"}
   {:country "CN" :region "32" :timezone "Asia/Chongqing"}
   {:country "CN" :region "33" :timezone "Asia/Chongqing"}
   {:country "CO" :timezone "America/Bogota"}
   {:country "CR" :timezone "America/Costa_Rica"}
   {:country "CU" :timezone "America/Havana"}
   {:country "CV" :timezone "Atlantic/Cape_Verde"}
   {:country "CW" :timezone "America/Curacao"}
   {:country "CX" :timezone "Indian/Christmas"}
   {:country "CY" :timezone "Asia/Nicosia"}
   {:country "CZ" :timezone "Europe/Prague"}
   {:country "DE" :timezone "Europe/Berlin"}
   {:country "DJ" :timezone "Africa/Djibouti"}
   {:country "DK" :timezone "Europe/Copenhagen"}
   {:country "DM" :timezone "America/Dominica"}
   {:country "DO" :timezone "America/Santo_Domingo"}
   {:country "DZ" :timezone "Africa/Algiers"}
   {:country "EC" :region "01" :timezone "Pacific/Galapagos"}
   {:country "EC" :region "02" :timezone "America/Guayaquil"}
   {:country "EC" :region "03" :timezone "America/Guayaquil"}
   {:country "EC" :region "04" :timezone "America/Guayaquil"}
   {:country "EC" :region "05" :timezone "America/Guayaquil"}
   {:country "EC" :region "06" :timezone "America/Guayaquil"}
   {:country "EC" :region "07" :timezone "America/Guayaquil"}
   {:country "EC" :region "08" :timezone "America/Guayaquil"}
   {:country "EC" :region "09" :timezone "America/Guayaquil"}
   {:country "EC" :region "10" :timezone "America/Guayaquil"}
   {:country "EC" :region "11" :timezone "America/Guayaquil"}
   {:country "EC" :region "12" :timezone "America/Guayaquil"}
   {:country "EC" :region "13" :timezone "America/Guayaquil"}
   {:country "EC" :region "14" :timezone "America/Guayaquil"}
   {:country "EC" :region "15" :timezone "America/Guayaquil"}
   {:country "EC" :region "17" :timezone "America/Guayaquil"}
   {:country "EC" :region "18" :timezone "America/Guayaquil"}
   {:country "EC" :region "19" :timezone "America/Guayaquil"}
   {:country "EC" :region "20" :timezone "America/Guayaquil"}
   {:country "EC" :region "22" :timezone "America/Guayaquil"}
   {:country "EC" :region "24" :timezone "America/Guayaquil"}
   {:country "EE" :timezone "Europe/Tallinn"}
   {:country "EG" :timezone "Africa/Cairo"}
   {:country "EH" :timezone "Africa/El_Aaiun"}
   {:country "ER" :timezone "Africa/Asmara"}
   {:country "ES" :region "07" :timezone "Europe/Madrid"}
   {:country "ES" :region "27" :timezone "Europe/Madrid"}
   {:country "ES" :region "29" :timezone "Europe/Madrid"}
   {:country "ES" :region "31" :timezone "Europe/Madrid"}
   {:country "ES" :region "32" :timezone "Europe/Madrid"}
   {:country "ES" :region "34" :timezone "Europe/Madrid"}
   {:country "ES" :region "39" :timezone "Europe/Madrid"}
   {:country "ES" :region "51" :timezone "Africa/Ceuta"}
   {:country "ES" :region "52" :timezone "Europe/Madrid"}
   {:country "ES" :region "53" :timezone "Atlantic/Canary"}
   {:country "ES" :region "54" :timezone "Europe/Madrid"}
   {:country "ES" :region "55" :timezone "Europe/Madrid"}
   {:country "ES" :region "56" :timezone "Europe/Madrid"}
   {:country "ES" :region "57" :timezone "Europe/Madrid"}
   {:country "ES" :region "58" :timezone "Europe/Madrid"}
   {:country "ES" :region "59" :timezone "Europe/Madrid"}
   {:country "ES" :region "60" :timezone "Europe/Madrid"}
   {:country "ET" :timezone "Africa/Addis_Ababa"}
   {:country "FI" :timezone "Europe/Helsinki"}
   {:country "FJ" :timezone "Pacific/Fiji"}
   {:country "FK" :timezone "Atlantic/Stanley"}
   {:country "FM" :timezone "Pacific/Pohnpei"}
   {:country "FO" :timezone "Atlantic/Faroe"}
   {:country "FR" :timezone "Europe/Paris"}
   {:country "FX" :timezone "Europe/Paris"}
   {:country "GA" :timezone "Africa/Libreville"}
   {:country "GB" :timezone "Europe/London"}
   {:country "GD" :timezone "America/Grenada"}
   {:country "GE" :timezone "Asia/Tbilisi"}
   {:country "GF" :timezone "America/Cayenne"}
   {:country "GG" :timezone "Europe/Guernsey"}
   {:country "GH" :timezone "Africa/Accra"}
   {:country "GI" :timezone "Europe/Gibraltar"}
   {:country "GL" :region "01" :timezone "America/Thule"}
   {:country "GL" :region "02" :timezone "America/Godthab"}
   {:country "GL" :region "03" :timezone "America/Godthab"}
   {:country "GM" :timezone "Africa/Banjul"}
   {:country "GN" :timezone "Africa/Conakry"}
   {:country "GP" :timezone "America/Guadeloupe"}
   {:country "GQ" :timezone "Africa/Malabo"}
   {:country "GR" :timezone "Europe/Athens"}
   {:country "GS" :timezone "Atlantic/South_Georgia"}
   {:country "GT" :timezone "America/Guatemala"}
   {:country "GU" :timezone "Pacific/Guam"}
   {:country "GW" :timezone "Africa/Bissau"}
   {:country "GY" :timezone "America/Guyana"}
   {:country "HK" :timezone "Asia/Hong_Kong"}
   {:country "HN" :timezone "America/Tegucigalpa"}
   {:country "HR" :timezone "Europe/Zagreb"}
   {:country "HT" :timezone "America/Port-au-Prince"}
   {:country "HU" :timezone "Europe/Budapest"}
   {:country "ID" :region "01" :timezone "Asia/Pontianak"}
   {:country "ID" :region "02" :timezone "Asia/Makassar"}
   {:country "ID" :region "03" :timezone "Asia/Jakarta"}
   {:country "ID" :region "04" :timezone "Asia/Jakarta"}
   {:country "ID" :region "05" :timezone "Asia/Jakarta"}
   {:country "ID" :region "06" :timezone "Asia/Jakarta"}
   {:country "ID" :region "07" :timezone "Asia/Jakarta"}
   {:country "ID" :region "08" :timezone "Asia/Jakarta"}
   {:country "ID" :region "09" :timezone "Asia/Jayapura"}
   {:country "ID" :region "10" :timezone "Asia/Jakarta"}
   {:country "ID" :region "11" :timezone "Asia/Pontianak"}
   {:country "ID" :region "12" :timezone "Asia/Makassar"}
   {:country "ID" :region "13" :timezone "Asia/Makassar"}
   {:country "ID" :region "14" :timezone "Asia/Makassar"}
   {:country "ID" :region "15" :timezone "Asia/Jakarta"}
   {:country "ID" :region "16" :timezone "Asia/Makassar"}
   {:country "ID" :region "17" :timezone "Asia/Makassar"}
   {:country "ID" :region "18" :timezone "Asia/Makassar"}
   {:country "ID" :region "19" :timezone "Asia/Pontianak"}
   {:country "ID" :region "20" :timezone "Asia/Makassar"}
   {:country "ID" :region "21" :timezone "Asia/Makassar"}
   {:country "ID" :region "22" :timezone "Asia/Makassar"}
   {:country "ID" :region "23" :timezone "Asia/Makassar"}
   {:country "ID" :region "24" :timezone "Asia/Jakarta"}
   {:country "ID" :region "25" :timezone "Asia/Pontianak"}
   {:country "ID" :region "26" :timezone "Asia/Pontianak"}
   {:country "ID" :region "28" :timezone "Asia/Jayapura"}
   {:country "ID" :region "29" :timezone "Asia/Makassar"}
   {:country "ID" :region "30" :timezone "Asia/Jakarta"}
   {:country "ID" :region "31" :timezone "Asia/Makassar"}
   {:country "ID" :region "32" :timezone "Asia/Jakarta"}
   {:country "ID" :region "33" :timezone "Asia/Jakarta"}
   {:country "ID" :region "34" :timezone "Asia/Makassar"}
   {:country "ID" :region "35" :timezone "Asia/Pontianak"}
   {:country "ID" :region "36" :timezone "Asia/Jayapura"}
   {:country "ID" :region "37" :timezone "Asia/Pontianak"}
   {:country "ID" :region "38" :timezone "Asia/Makassar"}
   {:country "ID" :region "39" :timezone "Asia/Jayapura"}
   {:country "ID" :region "40" :timezone "Asia/Pontianak"}
   {:country "ID" :region "41" :timezone "Asia/Makassar"}
   {:country "IE" :timezone "Europe/Dublin"}
   {:country "IL" :timezone "Asia/Jerusalem"}
   {:country "IM" :timezone "Europe/Isle_of_Man"}
   {:country "IN" :timezone "Asia/Kolkata"}
   {:country "IO" :timezone "Indian/Chagos"}
   {:country "IQ" :timezone "Asia/Baghdad"}
   {:country "IR" :timezone "Asia/Tehran"}
   {:country "IS" :timezone "Atlantic/Reykjavik"}
   {:country "IT" :timezone "Europe/Rome"}
   {:country "JE" :timezone "Europe/Jersey"}
   {:country "JM" :timezone "America/Jamaica"}
   {:country "JO" :timezone "Asia/Amman"}
   {:country "JP" :timezone "Asia/Tokyo"}
   {:country "KE" :timezone "Africa/Nairobi"}
   {:country "KG" :timezone "Asia/Bishkek"}
   {:country "KH" :timezone "Asia/Phnom_Penh"}
   {:country "KI" :timezone "Pacific/Tarawa"}
   {:country "KM" :timezone "Indian/Comoro"}
   {:country "KN" :timezone "America/St_Kitts"}
   {:country "KP" :timezone "Asia/Pyongyang"}
   {:country "KR" :timezone "Asia/Seoul"}
   {:country "KW" :timezone "Asia/Kuwait"}
   {:country "KY" :timezone "America/Cayman"}
   {:country "KZ" :region "01" :timezone "Asia/Almaty"}
   {:country "KZ" :region "02" :timezone "Asia/Almaty"}
   {:country "KZ" :region "03" :timezone "Asia/Qyzylorda"}
   {:country "KZ" :region "04" :timezone "Asia/Aqtobe"}
   {:country "KZ" :region "05" :timezone "Asia/Qyzylorda"}
   {:country "KZ" :region "06" :timezone "Asia/Aqtau"}
   {:country "KZ" :region "07" :timezone "Asia/Oral"}
   {:country "KZ" :region "08" :timezone "Asia/Qyzylorda"}
   {:country "KZ" :region "09" :timezone "Asia/Aqtau"}
   {:country "KZ" :region "10" :timezone "Asia/Qyzylorda"}
   {:country "KZ" :region "11" :timezone "Asia/Almaty"}
   {:country "KZ" :region "12" :timezone "Asia/Qyzylorda"}
   {:country "KZ" :region "13" :timezone "Asia/Aqtobe"}
   {:country "KZ" :region "14" :timezone "Asia/Qyzylorda"}
   {:country "KZ" :region "15" :timezone "Asia/Almaty"}
   {:country "KZ" :region "16" :timezone "Asia/Aqtobe"}
   {:country "KZ" :region "17" :timezone "Asia/Almaty"}
   {:country "LA" :timezone "Asia/Vientiane"}
   {:country "LB" :timezone "Asia/Beirut"}
   {:country "LC" :timezone "America/St_Lucia"}
   {:country "LI" :timezone "Europe/Vaduz"}
   {:country "LK" :timezone "Asia/Colombo"}
   {:country "LR" :timezone "Africa/Monrovia"}
   {:country "LS" :timezone "Africa/Maseru"}
   {:country "LT" :timezone "Europe/Vilnius"}
   {:country "LU" :timezone "Europe/Luxembourg"}
   {:country "LV" :timezone "Europe/Riga"}
   {:country "LY" :timezone "Africa/Tripoli"}
   {:country "MA" :timezone "Africa/Casablanca"}
   {:country "MC" :timezone "Europe/Monaco"}
   {:country "MD" :timezone "Europe/Chisinau"}
   {:country "ME" :timezone "Europe/Podgorica"}
   {:country "MF" :timezone "America/Marigot"}
   {:country "MG" :timezone "Indian/Antananarivo"}
   {:country "MH" :timezone "Pacific/Kwajalein"}
   {:country "MK" :timezone "Europe/Skopje"}
   {:country "ML" :timezone "Africa/Bamako"}
   {:country "MM" :timezone "Asia/Rangoon"}
   {:country "MN" :region "06" :timezone "Asia/Choibalsan"}
   {:country "MN" :region "11" :timezone "Asia/Ulaanbaatar"}
   {:country "MN" :region "17" :timezone "Asia/Choibalsan"}
   {:country "MN" :region "19" :timezone "Asia/Hovd"}
   {:country "MN" :region "20" :timezone "Asia/Ulaanbaatar"}
   {:country "MN" :region "21" :timezone "Asia/Ulaanbaatar"}
   {:country "MN" :region "25" :timezone "Asia/Ulaanbaatar"}
   {:country "MO" :timezone "Asia/Macau"}
   {:country "MP" :timezone "Pacific/Saipan"}
   {:country "MQ" :timezone "America/Martinique"}
   {:country "MR" :timezone "Africa/Nouakchott"}
   {:country "MS" :timezone "America/Montserrat"}
   {:country "MT" :timezone "Europe/Malta"}
   {:country "MU" :timezone "Indian/Mauritius"}
   {:country "MV" :timezone "Indian/Maldives"}
   {:country "MW" :timezone "Africa/Blantyre"}
   {:country "MX" :region "01" :timezone "America/Mexico_City"}
   {:country "MX" :region "02" :timezone "America/Tijuana"}
   {:country "MX" :region "03" :timezone "America/Hermosillo"}
   {:country "MX" :region "04" :timezone "America/Merida"}
   {:country "MX" :region "05" :timezone "America/Mexico_City"}
   {:country "MX" :region "06" :timezone "America/Chihuahua"}
   {:country "MX" :region "07" :timezone "America/Monterrey"}
   {:country "MX" :region "08" :timezone "America/Mexico_City"}
   {:country "MX" :region "09" :timezone "America/Mexico_City"}
   {:country "MX" :region "10" :timezone "America/Mazatlan"}
   {:country "MX" :region "11" :timezone "America/Mexico_City"}
   {:country "MX" :region "12" :timezone "America/Mexico_City"}
   {:country "MX" :region "13" :timezone "America/Mexico_City"}
   {:country "MX" :region "14" :timezone "America/Mazatlan"}
   {:country "MX" :region "15" :timezone "America/Chihuahua"}
   {:country "MX" :region "16" :timezone "America/Mexico_City"}
   {:country "MX" :region "17" :timezone "America/Mexico_City"}
   {:country "MX" :region "18" :timezone "America/Mazatlan"}
   {:country "MX" :region "19" :timezone "America/Monterrey"}
   {:country "MX" :region "20" :timezone "America/Mexico_City"}
   {:country "MX" :region "21" :timezone "America/Mexico_City"}
   {:country "MX" :region "22" :timezone "America/Mexico_City"}
   {:country "MX" :region "23" :timezone "America/Cancun"}
   {:country "MX" :region "24" :timezone "America/Mexico_City"}
   {:country "MX" :region "25" :timezone "America/Mazatlan"}
   {:country "MX" :region "26" :timezone "America/Hermosillo"}
   {:country "MX" :region "27" :timezone "America/Merida"}
   {:country "MX" :region "28" :timezone "America/Monterrey"}
   {:country "MX" :region "29" :timezone "America/Mexico_City"}
   {:country "MX" :region "30" :timezone "America/Mexico_City"}
   {:country "MX" :region "31" :timezone "America/Merida"}
   {:country "MX" :region "32" :timezone "America/Monterrey"}
   {:country "MY" :region "01" :timezone "Asia/Kuala_Lumpur"}
   {:country "MY" :region "02" :timezone "Asia/Kuala_Lumpur"}
   {:country "MY" :region "03" :timezone "Asia/Kuala_Lumpur"}
   {:country "MY" :region "04" :timezone "Asia/Kuala_Lumpur"}
   {:country "MY" :region "05" :timezone "Asia/Kuala_Lumpur"}
   {:country "MY" :region "06" :timezone "Asia/Kuala_Lumpur"}
   {:country "MY" :region "07" :timezone "Asia/Kuala_Lumpur"}
   {:country "MY" :region "08" :timezone "Asia/Kuala_Lumpur"}
   {:country "MY" :region "09" :timezone "Asia/Kuala_Lumpur"}
   {:country "MY" :region "11" :timezone "Asia/Kuching"}
   {:country "MY" :region "12" :timezone "Asia/Kuala_Lumpur"}
   {:country "MY" :region "13" :timezone "Asia/Kuala_Lumpur"}
   {:country "MY" :region "14" :timezone "Asia/Kuala_Lumpur"}
   {:country "MY" :region "15" :timezone "Asia/Kuching"}
   {:country "MY" :region "16" :timezone "Asia/Kuching"}
   {:country "MZ" :timezone "Africa/Maputo"}
   {:country "NA" :timezone "Africa/Windhoek"}
   {:country "NC" :timezone "Pacific/Noumea"}
   {:country "NE" :timezone "Africa/Niamey"}
   {:country "NF" :timezone "Pacific/Norfolk"}
   {:country "NG" :timezone "Africa/Lagos"}
   {:country "NI" :timezone "America/Managua"}
   {:country "NL" :timezone "Europe/Amsterdam"}
   {:country "NO" :timezone "Europe/Oslo"}
   {:country "NP" :timezone "Asia/Kathmandu"}
   {:country "NR" :timezone "Pacific/Nauru"}
   {:country "NU" :timezone "Pacific/Niue"}
   {:country "NZ" :region "85" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "E7" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "E8" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "E9" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "F1" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "F2" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "F3" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "F4" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "F5" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "F6" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "F7" :timezone "Pacific/Chatham"}
   {:country "NZ" :region "F8" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "F9" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "G1" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "G2" :timezone "Pacific/Auckland"}
   {:country "NZ" :region "G3" :timezone "Pacific/Auckland"}
   {:country "OM" :timezone "Asia/Muscat"}
   {:country "PA" :timezone "America/Panama"}
   {:country "PE" :timezone "America/Lima"}
   {:country "PF" :timezone "Pacific/Marquesas"}
   {:country "PG" :timezone "Pacific/Port_Moresby"}
   {:country "PH" :timezone "Asia/Manila"}
   {:country "PK" :timezone "Asia/Karachi"}
   {:country "PL" :timezone "Europe/Warsaw"}
   {:country "PM" :timezone "America/Miquelon"}
   {:country "PN" :timezone "Pacific/Pitcairn"}
   {:country "PR" :timezone "America/Puerto_Rico"}
   {:country "PS" :timezone "Asia/Gaza"}
   {:country "PT" :region "02" :timezone "Europe/Lisbon"}
   {:country "PT" :region "03" :timezone "Europe/Lisbon"}
   {:country "PT" :region "04" :timezone "Europe/Lisbon"}
   {:country "PT" :region "05" :timezone "Europe/Lisbon"}
   {:country "PT" :region "06" :timezone "Europe/Lisbon"}
   {:country "PT" :region "07" :timezone "Europe/Lisbon"}
   {:country "PT" :region "08" :timezone "Europe/Lisbon"}
   {:country "PT" :region "09" :timezone "Europe/Lisbon"}
   {:country "PT" :region "10" :timezone "Atlantic/Madeira"}
   {:country "PT" :region "11" :timezone "Europe/Lisbon"}
   {:country "PT" :region "13" :timezone "Europe/Lisbon"}
   {:country "PT" :region "14" :timezone "Europe/Lisbon"}
   {:country "PT" :region "16" :timezone "Europe/Lisbon"}
   {:country "PT" :region "17" :timezone "Europe/Lisbon"}
   {:country "PT" :region "18" :timezone "Europe/Lisbon"}
   {:country "PT" :region "19" :timezone "Europe/Lisbon"}
   {:country "PT" :region "20" :timezone "Europe/Lisbon"}
   {:country "PT" :region "21" :timezone "Europe/Lisbon"}
   {:country "PT" :region "22" :timezone "Europe/Lisbon"}
   {:country "PT" :region "23" :timezone "Atlantic/Azores"}
   {:country "PW" :timezone "Pacific/Palau"}
   {:country "PY" :timezone "America/Asuncion"}
   {:country "QA" :timezone "Asia/Qatar"}
   {:country "RE" :timezone "Indian/Reunion"}
   {:country "RO" :timezone "Europe/Bucharest"}
   {:country "RS" :timezone "Europe/Belgrade"}
   {:country "RU" :region "01" :timezone "Europe/Volgograd"}
   {:country "RU" :region "02" :timezone "Asia/Irkutsk"}
   {:country "RU" :region "03" :timezone "Asia/Novokuznetsk"}
   {:country "RU" :region "04" :timezone "Asia/Novosibirsk"}
   {:country "RU" :region "05" :timezone "Asia/Vladivostok"}
   {:country "RU" :region "06" :timezone "Europe/Moscow"}
   {:country "RU" :region "07" :timezone "Europe/Volgograd"}
   {:country "RU" :region "08" :timezone "Europe/Samara"}
   {:country "RU" :region "09" :timezone "Europe/Moscow"}
   {:country "RU" :region "10" :timezone "Europe/Moscow"}
   {:country "RU" :region "11" :timezone "Asia/Irkutsk"}
   {:country "RU" :region "12" :timezone "Europe/Volgograd"}
   {:country "RU" :region "13" :timezone "Asia/Yekaterinburg"}
   {:country "RU" :region "14" :timezone "Asia/Irkutsk"}
   {:country "RU" :region "15" :timezone "Asia/Anadyr"}
   {:country "RU" :region "16" :timezone "Europe/Samara"}
   {:country "RU" :region "17" :timezone "Europe/Volgograd"}
   {:country "RU" :region "18" :timezone "Asia/Krasnoyarsk"}
   {:country "RU" :region "20" :timezone "Asia/Irkutsk"}
   {:country "RU" :region "21" :timezone "Europe/Moscow"}
   {:country "RU" :region "22" :timezone "Europe/Volgograd"}
   {:country "RU" :region "23" :timezone "Europe/Kaliningrad"}
   {:country "RU" :region "24" :timezone "Europe/Volgograd"}
   {:country "RU" :region "25" :timezone "Europe/Moscow"}
   {:country "RU" :region "26" :timezone "Asia/Kamchatka"}
   {:country "RU" :region "27" :timezone "Europe/Volgograd"}
   {:country "RU" :region "28" :timezone "Europe/Moscow"}
   {:country "RU" :region "29" :timezone "Asia/Novokuznetsk"}
   {:country "RU" :region "30" :timezone "Asia/Vladivostok"}
   {:country "RU" :region "31" :timezone "Asia/Krasnoyarsk"}
   {:country "RU" :region "32" :timezone "Asia/Omsk"}
   {:country "RU" :region "33" :timezone "Asia/Yekaterinburg"}
   {:country "RU" :region "34" :timezone "Asia/Yekaterinburg"}
   {:country "RU" :region "35" :timezone "Asia/Yekaterinburg"}
   {:country "RU" :region "36" :timezone "Asia/Anadyr"}
   {:country "RU" :region "37" :timezone "Europe/Moscow"}
   {:country "RU" :region "38" :timezone "Europe/Volgograd"}
   {:country "RU" :region "39" :timezone "Asia/Krasnoyarsk"}
   {:country "RU" :region "40" :timezone "Asia/Yekaterinburg"}
   {:country "RU" :region "41" :timezone "Europe/Moscow"}
   {:country "RU" :region "42" :timezone "Europe/Moscow"}
   {:country "RU" :region "43" :timezone "Europe/Moscow"}
   {:country "RU" :region "44" :timezone "Asia/Magadan"}
   {:country "RU" :region "45" :timezone "Europe/Samara"}
   {:country "RU" :region "46" :timezone "Europe/Samara"}
   {:country "RU" :region "47" :timezone "Europe/Moscow"}
   {:country "RU" :region "48" :timezone "Europe/Moscow"}
   {:country "RU" :region "49" :timezone "Europe/Moscow"}
   {:country "RU" :region "50" :timezone "Asia/Yekaterinburg"}
   {:country "RU" :region "51" :timezone "Europe/Moscow"}
   {:country "RU" :region "52" :timezone "Europe/Moscow"}
   {:country "RU" :region "53" :timezone "Asia/Novosibirsk"}
   {:country "RU" :region "54" :timezone "Asia/Omsk"}
   {:country "RU" :region "55" :timezone "Europe/Samara"}
   {:country "RU" :region "56" :timezone "Europe/Moscow"}
   {:country "RU" :region "57" :timezone "Europe/Samara"}
   {:country "RU" :region "58" :timezone "Asia/Yekaterinburg"}
   {:country "RU" :region "59" :timezone "Asia/Vladivostok"}
   {:country "RU" :region "60" :timezone "Europe/Kaliningrad"}
   {:country "RU" :region "61" :timezone "Europe/Volgograd"}
   {:country "RU" :region "62" :timezone "Europe/Moscow"}
   {:country "RU" :region "63" :timezone "Asia/Yakutsk"}
   {:country "RU" :region "64" :timezone "Asia/Sakhalin"}
   {:country "RU" :region "65" :timezone "Europe/Samara"}
   {:country "RU" :region "66" :timezone "Europe/Moscow"}
   {:country "RU" :region "67" :timezone "Europe/Samara"}
   {:country "RU" :region "68" :timezone "Europe/Volgograd"}
   {:country "RU" :region "69" :timezone "Europe/Moscow"}
   {:country "RU" :region "70" :timezone "Europe/Volgograd"}
   {:country "RU" :region "71" :timezone "Asia/Yekaterinburg"}
   {:country "RU" :region "72" :timezone "Europe/Moscow"}
   {:country "RU" :region "73" :timezone "Europe/Samara"}
   {:country "RU" :region "74" :timezone "Asia/Krasnoyarsk"}
   {:country "RU" :region "75" :timezone "Asia/Novosibirsk"}
   {:country "RU" :region "76" :timezone "Europe/Moscow"}
   {:country "RU" :region "77" :timezone "Europe/Moscow"}
   {:country "RU" :region "78" :timezone "Asia/Yekaterinburg"}
   {:country "RU" :region "79" :timezone "Asia/Irkutsk"}
   {:country "RU" :region "80" :timezone "Asia/Yekaterinburg"}
   {:country "RU" :region "81" :timezone "Europe/Samara"}
   {:country "RU" :region "82" :timezone "Asia/Irkutsk"}
   {:country "RU" :region "83" :timezone "Europe/Moscow"}
   {:country "RU" :region "84" :timezone "Europe/Volgograd"}
   {:country "RU" :region "85" :timezone "Europe/Moscow"}
   {:country "RU" :region "86" :timezone "Europe/Moscow"}
   {:country "RU" :region "87" :timezone "Asia/Novosibirsk"}
   {:country "RU" :region "88" :timezone "Europe/Moscow"}
   {:country "RU" :region "89" :timezone "Asia/Vladivostok"}
   {:country "RU" :region "90" :timezone "Asia/Yekaterinburg"}
   {:country "RU" :region "91" :timezone "Asia/Krasnoyarsk"}
   {:country "RU" :region "92" :timezone "Asia/Anadyr"}
   {:country "RU" :region "93" :timezone "Asia/Irkutsk"}
   {:country "RW" :timezone "Africa/Kigali"}
   {:country "SA" :timezone "Asia/Riyadh"}
   {:country "SB" :timezone "Pacific/Guadalcanal"}
   {:country "SC" :timezone "Indian/Mahe"}
   {:country "SD" :timezone "Africa/Khartoum"}
   {:country "SE" :timezone "Europe/Stockholm"}
   {:country "SG" :timezone "Asia/Singapore"}
   {:country "SH" :timezone "Atlantic/St_Helena"}
   {:country "SI" :timezone "Europe/Ljubljana"}
   {:country "SJ" :timezone "Arctic/Longyearbyen"}
   {:country "SK" :timezone "Europe/Bratislava"}
   {:country "SL" :timezone "Africa/Freetown"}
   {:country "SM" :timezone "Europe/San_Marino"}
   {:country "SN" :timezone "Africa/Dakar"}
   {:country "SO" :timezone "Africa/Mogadishu"}
   {:country "SR" :timezone "America/Paramaribo"}
   {:country "SS" :timezone "Africa/Juba"}
   {:country "ST" :timezone "Africa/Sao_Tome"}
   {:country "SV" :timezone "America/El_Salvador"}
   {:country "SX" :timezone "America/Curacao"}
   {:country "SY" :timezone "Asia/Damascus"}
   {:country "SZ" :timezone "Africa/Mbabane"}
   {:country "TC" :timezone "America/Grand_Turk"}
   {:country "TD" :timezone "Africa/Ndjamena"}
   {:country "TF" :timezone "Indian/Kerguelen"}
   {:country "TG" :timezone "Africa/Lome"}
   {:country "TH" :timezone "Asia/Bangkok"}
   {:country "TJ" :timezone "Asia/Dushanbe"}
   {:country "TK" :timezone "Pacific/Fakaofo"}
   {:country "TL" :timezone "Asia/Dili"}
   {:country "TM" :timezone "Asia/Ashgabat"}
   {:country "TN" :timezone "Africa/Tunis"}
   {:country "TO" :timezone "Pacific/Tongatapu"}
   {:country "TR" :timezone "Asia/Istanbul"}
   {:country "TT" :timezone "America/Port_of_Spain"}
   {:country "TV" :timezone "Pacific/Funafuti"}
   {:country "TW" :timezone "Asia/Taipei"}
   {:country "TZ" :timezone "Africa/Dar_es_Salaam"}
   {:country "UA" :region "01" :timezone "Europe/Kiev"}
   {:country "UA" :region "02" :timezone "Europe/Kiev"}
   {:country "UA" :region "03" :timezone "Europe/Uzhgorod"}
   {:country "UA" :region "04" :timezone "Europe/Zaporozhye"}
   {:country "UA" :region "05" :timezone "Europe/Zaporozhye"}
   {:country "UA" :region "06" :timezone "Europe/Uzhgorod"}
   {:country "UA" :region "07" :timezone "Europe/Zaporozhye"}
   {:country "UA" :region "08" :timezone "Europe/Simferopol"}
   {:country "UA" :region "09" :timezone "Europe/Kiev"}
   {:country "UA" :region "10" :timezone "Europe/Zaporozhye"}
   {:country "UA" :region "11" :timezone "Europe/Simferopol"}
   {:country "UA" :region "12" :timezone "Europe/Kiev"}
   {:country "UA" :region "13" :timezone "Europe/Kiev"}
   {:country "UA" :region "14" :timezone "Europe/Zaporozhye"}
   {:country "UA" :region "15" :timezone "Europe/Uzhgorod"}
   {:country "UA" :region "16" :timezone "Europe/Zaporozhye"}
   {:country "UA" :region "17" :timezone "Europe/Simferopol"}
   {:country "UA" :region "18" :timezone "Europe/Zaporozhye"}
   {:country "UA" :region "19" :timezone "Europe/Kiev"}
   {:country "UA" :region "20" :timezone "Europe/Simferopol"}
   {:country "UA" :region "21" :timezone "Europe/Kiev"}
   {:country "UA" :region "22" :timezone "Europe/Uzhgorod"}
   {:country "UA" :region "23" :timezone "Europe/Kiev"}
   {:country "UA" :region "24" :timezone "Europe/Uzhgorod"}
   {:country "UA" :region "25" :timezone "Europe/Uzhgorod"}
   {:country "UA" :region "26" :timezone "Europe/Zaporozhye"}
   {:country "UA" :region "27" :timezone "Europe/Kiev"}
   {:country "UG" :timezone "Africa/Kampala"}
   {:country "UM" :timezone "Pacific/Wake"}
   {:country "US" :region "AK" :timezone "America/Anchorage"}
   {:country "US" :region "AL" :timezone "America/Chicago"}
   {:country "US" :region "AR" :timezone "America/Chicago"}
   {:country "US" :region "AZ" :timezone "America/Phoenix"}
   {:country "US" :region "CA" :timezone "America/Los_Angeles"}
   {:country "US" :region "CO" :timezone "America/Denver"}
   {:country "US" :region "CT" :timezone "America/New_York"}
   {:country "US" :region "DC" :timezone "America/New_York"}
   {:country "US" :region "DE" :timezone "America/New_York"}
   {:country "US" :region "FL" :timezone "America/New_York"}
   {:country "US" :region "GA" :timezone "America/New_York"}
   {:country "US" :region "HI" :timezone "Pacific/Honolulu"}
   {:country "US" :region "IA" :timezone "America/Chicago"}
   {:country "US" :region "ID" :timezone "America/Denver"}
   {:country "US" :region "IL" :timezone "America/Chicago"}
   {:country "US" :region "IN" :timezone "America/Indiana/Indianapolis"}
   {:country "US" :region "KS" :timezone "America/Chicago"}
   {:country "US" :region "KY" :timezone "America/New_York"}
   {:country "US" :region "LA" :timezone "America/Chicago"}
   {:country "US" :region "MA" :timezone "America/New_York"}
   {:country "US" :region "MD" :timezone "America/New_York"}
   {:country "US" :region "ME" :timezone "America/New_York"}
   {:country "US" :region "MI" :timezone "America/New_York"}
   {:country "US" :region "MN" :timezone "America/Chicago"}
   {:country "US" :region "MO" :timezone "America/Chicago"}
   {:country "US" :region "MS" :timezone "America/Chicago"}
   {:country "US" :region "MT" :timezone "America/Denver"}
   {:country "US" :region "NC" :timezone "America/New_York"}
   {:country "US" :region "ND" :timezone "America/Chicago"}
   {:country "US" :region "NE" :timezone "America/Chicago"}
   {:country "US" :region "NH" :timezone "America/New_York"}
   {:country "US" :region "NJ" :timezone "America/New_York"}
   {:country "US" :region "NM" :timezone "America/Denver"}
   {:country "US" :region "NV" :timezone "America/Los_Angeles"}
   {:country "US" :region "NY" :timezone "America/New_York"}
   {:country "US" :region "OH" :timezone "America/New_York"}
   {:country "US" :region "OK" :timezone "America/Chicago"}
   {:country "US" :region "OR" :timezone "America/Los_Angeles"}
   {:country "US" :region "PA" :timezone "America/New_York"}
   {:country "US" :region "RI" :timezone "America/New_York"}
   {:country "US" :region "SC" :timezone "America/New_York"}
   {:country "US" :region "SD" :timezone "America/Chicago"}
   {:country "US" :region "TN" :timezone "America/Chicago"}
   {:country "US" :region "TX" :timezone "America/Chicago"}
   {:country "US" :region "UT" :timezone "America/Denver"}
   {:country "US" :region "VA" :timezone "America/New_York"}
   {:country "US" :region "VT" :timezone "America/New_York"}
   {:country "US" :region "WA" :timezone "America/Los_Angeles"}
   {:country "US" :region "WI" :timezone "America/Chicago"}
   {:country "US" :region "WV" :timezone "America/New_York"}
   {:country "US" :region "WY" :timezone "America/Denver"}
   {:country "UY" :timezone "America/Montevideo"}
   {:country "UZ" :region "01" :timezone "Asia/Tashkent"}
   {:country "UZ" :region "02" :timezone "Asia/Samarkand"}
   {:country "UZ" :region "03" :timezone "Asia/Tashkent"}
   {:country "UZ" :region "05" :timezone "Asia/Samarkand"}
   {:country "UZ" :region "06" :timezone "Asia/Tashkent"}
   {:country "UZ" :region "07" :timezone "Asia/Samarkand"}
   {:country "UZ" :region "08" :timezone "Asia/Samarkand"}
   {:country "UZ" :region "09" :timezone "Asia/Samarkand"}
   {:country "UZ" :region "10" :timezone "Asia/Samarkand"}
   {:country "UZ" :region "12" :timezone "Asia/Samarkand"}
   {:country "UZ" :region "13" :timezone "Asia/Tashkent"}
   {:country "UZ" :region "14" :timezone "Asia/Tashkent"}
   {:country "VA" :timezone "Europe/Vatican"}
   {:country "VC" :timezone "America/St_Vincent"}
   {:country "VE" :timezone "America/Caracas"}
   {:country "VG" :timezone "America/Tortola"}
   {:country "VI" :timezone "America/St_Thomas"}
   {:country "VN" :timezone "Asia/Phnom_Penh"}
   {:country "VU" :timezone "Pacific/Efate"}
   {:country "WF" :timezone "Pacific/Wallis"}
   {:country "WS" :timezone "Pacific/Pago_Pago"}
   {:country "YE" :timezone "Asia/Aden"}
   {:country "YT" :timezone "Indian/Mayotte"}
   {:country "YU" :timezone "Europe/Belgrade"}
   {:country "ZA" :timezone "Africa/Johannesburg"}
   {:country "ZM" :timezone "Africa/Lusaka"}
   {:country "ZW" :timezone "Africa/Harare"}])

(def supported
  (vec (sort (distinct (map :timezone timezones)))))
